import { useLocation } from "@gatsbyjs/reach-router";
import { useActions } from "hooks";
import { usePermissions } from "./useHasPermission";
import { usePromotionClaims } from "hooks/firestore/v2/user/usePromotionClaims";
import Route from "route-parser";
import * as walletSlice from "sections/Wallet/walletSlice";

export const useWallet = () => {
  const { claims, isLoading: claimsLoading } = usePromotionClaims();
  const permissions = usePermissions();
  const location = useLocation();

  const parsedRoute = new Route(
    "(/:regionCode)/wallet(/:section)(/:subsection)(/)",
  ).match(location.pathname) as {
    regionCode: string;
    section: string;
    subsection: string;
  };

  const section = parsedRoute?.section || "statement";
  const subsection = parsedRoute?.subsection || "";

  return {
    tab: section,
    subsection,
    claims,
    loading: claimsLoading,
    permissions,
  };
};

export const useWalletActions = () => {
  const [
    addCashCardAttempt,
    addPicklebetCardAttempt,
    removeCashCardAttempt,
    removePicklebetCardAttempt,
    depositFundsAttempt,
    depositFundsFailure,
    firstTimeDeposit,
    attemptRemoveBankAccount,
    withdrawCashAttempt,
    addedBankDetails,
    buySkrAttempt,
    attemptRegisterAddress,
    updateBonusCode,
    setBonusState,
    setSkrAccount,
    cancelWithdrawal,
    doAddBank,
    doMWDeposit,
    doAddCard,
    doBeginVerification,
    doAttemptRemoveBankAccount,
    doCancelWithdrawal,
    doClearBonusState,
    doConfirmCard,
    doLoadDefaultBonus,
    doQueueLoadDefaultBonus,
    doRemoveCard,
    doRemoveBankAccount,
    doShowError,
    doWithdrawCash,
    doVerifyCard,
    doSkrillDeposit,
    generatePayID,
    setAppleDepositStatus,
    setGoogleDepositStatus,
    setDepositAmount,
  ] = useActions([
    walletSlice.addCashCardAttempt,
    walletSlice.addPicklebetCardAttempt,
    walletSlice.removeCashCardAttempt,
    walletSlice.removePicklebetCardAttempt,
    walletSlice.depositFundsAttempt,
    walletSlice.depositFundsFailure,
    walletSlice.firstTimeDeposit,
    walletSlice.attemptRemoveBankAccount,
    walletSlice.withdrawCashAttempt,
    walletSlice.addedBankDetails,
    walletSlice.buySkrAttempt,
    walletSlice.attemptRegisterAddress,
    walletSlice.updateBonusCode,
    walletSlice.setBonusState,
    walletSlice.setSkrAccount,
    walletSlice.cancelWithdrawal,
    walletSlice.doAddBank,
    walletSlice.doMWDeposit,
    walletSlice.doAddCard,
    walletSlice.doBeginVerification,
    walletSlice.doAttemptRemoveBankAccount,
    walletSlice.doCancelWithdrawal,
    walletSlice.doClearBonusState,
    walletSlice.doConfirmCard,
    walletSlice.doLoadDefaultBonus,
    walletSlice.doQueueLoadDefaultBonus,
    walletSlice.doRemoveCard,
    walletSlice.doRemoveBankAccount,
    walletSlice.doShowError,
    walletSlice.doWithdrawCash,
    walletSlice.doVerifyCard,
    walletSlice.doSkrillDeposit,
    walletSlice.generatePayID,
    walletSlice.setAppleDepositStatus,
    walletSlice.setGoogleDepositStatus,
    walletSlice.setDepositAmount,
  ]);

  return {
    addCashCardAttempt,
    addPicklebetCardAttempt,
    removeCashCardAttempt,
    removePicklebetCardAttempt,
    depositFundsAttempt,
    depositFundsFailure,
    firstTimeDeposit,
    attemptRemoveBankAccount,
    withdrawCashAttempt,
    addedBankDetails,
    buySkrAttempt,
    attemptRegisterAddress,
    updateBonusCode,
    setBonusState,
    setSkrAccount,
    cancelWithdrawal,
    doAddBank,
    doMWDeposit,
    doAddCard,
    doBeginVerification,
    doAttemptRemoveBankAccount,
    doCancelWithdrawal,
    doClearBonusState,
    doConfirmCard,
    doLoadDefaultBonus,
    doQueueLoadDefaultBonus,
    doRemoveCard,
    doRemoveBankAccount,
    doShowError,
    doWithdrawCash,
    doVerifyCard,
    doSkrillDeposit,
    generatePayID,
    setAppleDepositStatus,
    setGoogleDepositStatus,
    setDepositAmount,
  };
};
